const React = require('react');
const { useEffect, useRef } = React;
const { useLoaderData } = require('react-router-dom');
const { default: styled } = require('@emotion/styled');

// const Overlay = styled.div`
//     position: fixed;
//     inset: 0;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     background: #ffffff;
//     z-index: 2147483647;
// `;

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    z-index: 2147483647;
`;

const LdsRoller = styled.div`
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    & div {
        animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        transform-origin: 40px 40px;
    }
    & div:after {
        content: " ";
        display: block;
        position: absolute;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.4);
        margin: -4px 0 0 -4px;
    }
    & div:nth-of-type(1) { animation-delay: -0.036s; }
    & div:nth-of-type(1):after { top: 63px; left: 63px; }
    & div:nth-of-type(2) { animation-delay: -0.072s; }
    & div:nth-of-type(2):after { top: 68px; left: 56px; }
    & div:nth-of-type(3) { animation-delay: -0.108s; }
    & div:nth-of-type(3):after { top: 71px; left: 48px; }
    & div:nth-of-type(4) { animation-delay: -0.144s; }
    & div:nth-of-type(4):after { top: 72px; left: 40px; }
    & div:nth-of-type(5) { animation-delay: -0.18s; }
    & div:nth-of-type(5):after { top: 71px; left: 32px; }
    & div:nth-of-type(6) { animation-delay: -0.216s; }
    & div:nth-of-type(6):after { top: 68px; left: 24px; }
    & div:nth-of-type(7) { animation-delay: -0.252s; }
    & div:nth-of-type(7):after { top: 63px; left: 17px; }
    & div:nth-of-type(8) { animation-delay: -0.288s; }
    & div:nth-of-type(8):after { top: 56px; left: 12px; }
    @keyframes lds-roller {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;
// const LdsSpinner = styled.div`
//     color: #666;
//     display: inline-block;
//     position: relative;
//     width: 64px;
//     height: 64px;
//     & > div {
//         transform-origin: 32px 32px;
//         animation: spin-fade 1.2s linear infinite;
//     }
//     & > div:after {
//         content: ' ';
//         display: block;
//         position: absolute;
//         top: 3px;
//         left: 29px;
//         width: 5px;
//         height: 14px;
//         border-radius: 20%;
//         background: currentColor;
//     }
//     ${[...Array(12)].map((_, i) => `
//         & > div:nth-of-type(${i + 1}) {
//             transform: rotate(${i * 30}deg);
//             animation-delay: ${(-1.2 + (i * 0.1)).toFixed(2)}s;
//         }
//     `).join('')}
//     @keyframes spin-fade {
//         0% { opacity: 1; }
//         100% { opacity: 0; }
//     }
// `;

const readCookie = (name) => {
    if (typeof document === 'undefined') return null;
    const re = new RegExp(`(?:^|;\\s*)${name}=([^;]*)`);
    const match = document.cookie.match(re);
    return match ? match[1] : null;
};

const hasIdentificationCookies = () => {
    const fp = readCookie('asp_fp');
    if (!fp || !/^[a-f0-9]{32}$/i.test(fp)) return false;
    const info = readCookie('asp_info');
    return typeof info === 'string' && info.length > 0;
};

const FingerprintOverlay = () => {
    const {
        originalUrl = '/',
        minOverlayTime = 300,
        redirectTimeout = 10000,
        debug = false,
    } = useLoaderData();

    const doneRef = useRef(false);

    useEffect(() => {
        let cookieTimer = null;
        let minOverlayTimer = null;
        let hardTimeout = null;

        const redirectToOriginal = () => {
            if (doneRef.current) return;
            doneRef.current = true;
            minOverlayTimer = setTimeout(() => {
                try {
                    window.history.replaceState(null, '', originalUrl);
                } catch {
                    /* replaceState can throw on cross-origin originals; fall through to reload */
                }
                window.location.reload();
            }, minOverlayTime);
        };

        if (typeof window !== 'undefined' && window.__securityBridge) {
            try {
                window.__securityBridge.subscribe('browser_client', redirectToOriginal);
            } catch {
                /* bridge present but misbehaving; rely on cookie fallback */
            }
        }

        cookieTimer = setInterval(() => {
            if (hasIdentificationCookies()) {
                clearInterval(cookieTimer);
                redirectToOriginal();
            }
        }, 300);

        hardTimeout = setTimeout(() => {
            if (debug) {
                // eslint-disable-next-line no-console
                console.warn('[FingerprintOverlayTest] collection timed out; redirecting anyway');
            }
            redirectToOriginal();
        }, redirectTimeout);

        return () => {
            if (typeof window !== 'undefined' && window.__securityBridge) {
                try { window.__securityBridge.unsubscribe('browser_client', redirectToOriginal); }
                catch { /* noop */ }
            }
            if (cookieTimer) clearInterval(cookieTimer);
            if (minOverlayTimer) clearTimeout(minOverlayTimer);
            if (hardTimeout) clearTimeout(hardTimeout);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        // <Overlay>
        //     <LdsSpinner>
        //         {[...Array(12)].map((_, i) => (<div key={i} />))}
        //     </LdsSpinner>
        // </Overlay>

        <Overlay>
            <LdsRoller>
                <div /><div /><div /><div />
                <div /><div /><div /><div />
            </LdsRoller>
        </Overlay>
    );
};

module.exports = FingerprintOverlay;
